// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TripModal .FormField-Label {
  color: var(--bs-primary) !important;
}
.TripModal .FormField-Input.form-switch > .form-check-label {
  margin-left: 1rem;
  text-align: left !important;
}
.TripModal .ant-picker-input input {
  padding-right: 0;
}
.TripModal .ant-picker-input .ant-picker-suffix {
  margin-right: 0.35rem;
}
.TripModal .add-stop-btn {
  background: none;
  color: var(--bs-primary);
  border: 1px solid var(--bs-primary);
}
.TripModal .add-stop-btn i {
  color: var(--bs-green);
  border: 1px solid var(--bs-green);
  border-radius: var(--bs-border-radius-lg);
}
.TripModal .add-stop-btn:hover {
  background-color: var(--bs-green);
  color: #fff;
}
.TripModal .add-stop-btn:hover i {
  transition: border 0.5s;
  border: 1px solid #fff;
  color: #fff;
}
.TripModal .ant-drawer-body .Calendar {
  padding: 0.5rem;
}
.TripModal .ant-drawer-body .Calendar .Calendar-Body {
  padding: 0 0 0.35rem 0;
}
.TripModal .ant-drawer-body .Calendar .Calendar-Body .row-cols-7 {
  height: 1.72rem !important;
}
.TripModal .ant-drawer-body .Calendar .Calendar-Body .row-cols-7 .col {
  padding: 0;
  height: 100% !important;
}
.TripModal .ant-drawer-body .Calendar .Calendar-Body .row-cols-7 .col .day {
  margin: 0;
  height: 100%;
}
.TripModal .ant-drawer-body .Calendar + .Field {
  margin-bottom: 0;
  padding-bottom: 0;
}
.TripModal .ant-drawer-body .view-more-button {
  color: var(--bs-primary);
  border-bottom: 1px solid var(--bs-primary) !important;
  border-radius: 0;
  padding: 0.2rem 0.5rem;
  margin: 0.25rem 0;
  font-size: 1.15rem;
}
.TripModal .ant-drawer-body .form-check-label {
  font-size: 1rem;
}
.TripModal .ant-drawer-body .form-switch .form-check-input {
  font-size: 1.35rem;
}
.TripModal .DynamicContent-DrawerTabs > button {
  padding: 0.85rem;
}
.TripModal .DynamicContent-DrawerTabs > button .sv {
  font-size: 1.5rem;
}
.TripModal .IncidentView .TextArea {
  height: 75vh;
}
.TripModal .TripFormUpload {
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/features/Trips/components/TripModal/styles.scss"],"names":[],"mappings":"AACE;EACE,mCAAA;AAAJ;AAGE;EACE,iBAAA;EACA,2BAAA;AADJ;AAKI;EACE,gBAAA;AAHN;AAKI;EACE,qBAAA;AAHN;AAOE;EACE,gBAAA;EACA,wBAAA;EACA,mCAAA;AALJ;AAMI;EACE,sBAAA;EACA,iCAAA;EACA,yCAAA;AAJN;AAMI;EACE,iCAAA;EACA,WAAA;AAJN;AAKM;EACE,uBAAA;EACA,sBAAA;EACA,WAAA;AAHR;AASI;EACE,eAAA;AAPN;AASM;EACE,sBAAA;AAPR;AASQ;EACE,0BAAA;AAPV;AAQU;EACE,UAAA;EACA,uBAAA;AANZ;AAQY;EACE,SAAA;EACA,YAAA;AANd;AAYM;EACE,gBAAA;EACA,iBAAA;AAVR;AAcI;EACE,wBAAA;EACA,qDAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAZN;AAeI;EACE,eAAA;AAbN;AAiBM;EACE,kBAAA;AAfR;AAqBI;EACE,gBAAA;AAnBN;AAqBM;EACE,iBAAA;AAnBR;AAyBI;EACE,YAAA;AAvBN;AA2BE;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAzBJ","sourcesContent":[".TripModal {\n  .FormField-Label {\n    color: var(--bs-primary) !important;\n  }\n\n  .FormField-Input.form-switch > .form-check-label {\n    margin-left: 1rem;\n    text-align: left !important;\n  }\n\n  .ant-picker-input {\n    input {\n      padding-right: 0;\n    }\n    .ant-picker-suffix {\n      margin-right: 0.35rem;\n    }\n  }\n\n  .add-stop-btn {\n    background: none;\n    color: var(--bs-primary);\n    border: 1px solid var(--bs-primary);\n    i {\n      color: var(--bs-green);\n      border: 1px solid var(--bs-green);\n      border-radius: var(--bs-border-radius-lg);\n    }\n    &:hover {\n      background-color: var(--bs-green);\n      color: #fff;\n      i {\n        transition: border 0.5s;\n        border: 1px solid #fff;\n        color: #fff;\n      }\n    }\n  }\n\n  .ant-drawer-body {\n    .Calendar {\n      padding: 0.5rem;\n\n      .Calendar-Body {\n        padding: 0 0 0.35rem 0;\n\n        .row-cols-7 {\n          height: 1.72rem !important;\n          .col {\n            padding: 0;\n            height: 100% !important;\n\n            .day {\n              margin: 0;\n              height: 100%;\n            }\n          }\n        }\n      }\n\n      + .Field {\n        margin-bottom: 0;\n        padding-bottom: 0;\n      }\n    }\n\n    .view-more-button {\n      color: var(--bs-primary);\n      border-bottom: 1px solid var(--bs-primary) !important;\n      border-radius: 0;\n      padding: 0.2rem 0.5rem;\n      margin: 0.25rem 0;\n      font-size: 1.15rem;\n    }\n\n    .form-check-label {\n      font-size: 1rem;\n    }\n\n    .form-switch {\n      .form-check-input {\n        font-size: 1.35rem;\n      }\n    }\n  }\n\n  .DynamicContent-DrawerTabs {\n    > button {\n      padding: 0.85rem;\n\n      .sv {\n        font-size: 1.5rem;\n      }\n    }\n  }\n\n  .IncidentView {\n    .TextArea {\n      height: 75vh;\n    }\n  }\n\n  .TripFormUpload {\n    padding-left: 0;\n    padding-right: 0;\n    margin-bottom: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
